import { LogOut } from 'lucide-react'
import { toast } from 'sonner'

import { AppLogo } from '@/components/app-logo'
import { MainNav } from '@/components/main-nav'
import { ThemeToggle } from '@/components/theme-toggle'
import { Button } from '@/components/ui/button'

/** Global application header: brand, primary navigation, and account actions. */
export function AppHeader() {
  return (
    <header className="flex h-16 shrink-0 items-center justify-between gap-4 border-b bg-background px-5">
      <AppLogo />
      <div className="flex items-center gap-2">
        <MainNav />
        <span className="mx-1 hidden h-5 w-px bg-border md:block" />
        <ThemeToggle />
        <Button
          variant="ghost"
          size="icon"
          aria-label="Sign out"
          onClick={() => toast('Signed out (demo)')}
        >
          <LogOut className="size-4" />
        </Button>
      </div>
    </header>
  )
}
